export const popularMetaregions = [
  // Убираем на зимний сезон
  // {
  //   metaregion: {
  //     title: 'Средиземное море',
  //     link: '/explore/Moscow-Russia/Mediterranean',
  //     image_url:
  //       'https://img.cdn.level.travel/seo_images/GR/x543x285_Greece-tiny.jpg',
  //   },
  //   regions: [
  //     { title: 'Турция', link: '/explore/Moscow-Russia/Turkey' },
  //     { title: 'Кипр (с пересадкой)', link: '/explore/Moscow-Russia/Cyprus' },
  //     { title: 'Израиль', link: '/explore/Moscow-Russia/Israel' },
  //     { title: 'Испания (без перелета)', link: '/tophotels/any/Spain' },
  //     { title: 'Тунис (с пересадкой)', link: '/explore/Moscow-Russia/Tunisia' },
  //     { title: 'Греция (без перелета)', link: '/tophotels/any/Greece' },
  //     {
  //       title: 'Черногория (с пересадкой)',
  //       link: '/explore/Moscow-Russia/Montenegro',
  //     },
  //   ],
  // },
  {
    metaregion: {
      title: 'Тропические курорты',
      link: '/explore/Moscow-Russia/Tropics',
      image_url:
        'https://img.cdn.level.travel/seo_images/TH/x543x285_Tailand-tiny.jpg',
    },
    regions: [
      { title: 'Египет', link: '/explore/Moscow-Russia/Egypt' },
      { title: 'Таиланд', link: '/explore/Moscow-Russia/Thailand' },
      { title: 'Гоа', link: '/explore/Moscow-Russia/Goa-India/october' },
      {
        title: 'Вьетнам',
        link: '/explore/Moscow-Russia/Vietnam',
      },
      { title: 'Венесуэла', link: '/explore/Moscow-Russia/Venezuela' },
      {
        title: 'Танзания (с пересадкой)',
        link: '/explore/Moscow-Russia/Tanzania',
      },
    ],
  },
  {
    metaregion: {
      title: 'Тропические острова',
      link: '/explore/Moscow-Russia/Islands',
      image_url:
        'https://img.cdn.level.travel/seo_images/MV/x543x285_Maldives-tiny.jpg',
    },
    regions: [
      { title: 'Пхукет', link: '/explore/Moscow-Russia/Phuket-Thailand' },
      { title: 'Куба', link: '/explore/Moscow-Russia/Cuba' },
      { title: 'Мальдивы', link: '/explore/Moscow-Russia/Maldives' },
      { title: 'Сейшелы', link: '/explore/Moscow-Russia/Seychelles' },
      { title: 'Шри-Ланка', link: '/explore/Moscow-Russia/Sri_Lanka' },
      {
        title: 'Бали (с пересадкой)',
        link: '/explore/Moscow-Russia/Bali_Island-Indonesia',
      },
      {
        title: 'Хайнань',
        link: '/explore/Moscow-Russia/Haynan-China',
      },
      { title: 'Маврикий', link: '/explore/Moscow-Russia/Mauritius' },
    ],
  },
  {
    metaregion: {
      title: 'Горнолыжные курорты',
      link: '/explore/Moscow-Russia/Ski_resorts/february',
      image_url:
        'https://img.cdn.level.travel/seo_images/cities/119588/image_3-7.jpg',
    },
    regions: [
      {
        title: 'Красная Поляна',
        link: '/explore/Moscow-Russia/Krasnaya_Polyana-Russia/february',
      },
      {
        title: 'Шерегеш',
        link: '/explore/Moscow-Russia/Sheregesh-Russia/february',
      },
      {
        title: 'Домбай',
        link: '/explore/Moscow-Russia/Dombay-Russia/february',
      },
      {
        title: 'Архыз',
        link: '/explore/Moscow-Russia/Arkhyz-Russia/february',
      },
      {
        title: 'Приэльбрусье',
        link: '/explore/Moscow-Russia/Prielbrusye-Russia/february',
      },
      {
        title: 'Гудаури (Грузия)',
        link: '/explore/Moscow-Russia/Gudauri-Georgia/february',
      },
      {
        title: 'Цахкадзор (Армения)',
        link: '/explore/Moscow-Russia/Tsakhkadzor-Armenia/february',
      },
      {
        title: 'Хибины',
        link: '/explore/Moscow-Russia/Khibiny-Russia/february',
      },
    ],
  },
  {
    metaregion: {
      title: 'Ближний Восток',
      link: '/explore/Moscow-Russia/Middle_East_countries',
      image_url: 'https://img.cdn.level.travel/seo_images/AE/UAE-tiny.jpg',
    },
    regions: [
      { title: 'ОАЭ', link: '/explore/Moscow-Russia/UAE' },
      { title: 'Бахрейн', link: '/explore/Moscow-Russia/Bahrain' },
      { title: 'Катар', link: '/explore/Moscow-Russia/Qatar' },
      { title: 'Оман', link: '/explore/Moscow-Russia/Oman' },
      {
        title: 'Саудовская Аравия',
        link: '/explore/Moscow-Russia/Saudi_Arabia',
      },
      {
        title: 'Иордания (с пересадкой)',
        link: '/explore/Moscow-Russia/Jordan',
      },
    ],
  },
  {
    metaregion: {
      title: 'Юго-Восточная Азия',
      link: '/explore/Moscow-Russia/Southeast_Asia',
      image_url:
        'https://img.cdn.level.travel/seo_images/ID/Indonesia-tiny.jpg',
    },
    regions: [
      { title: 'Таиланд', link: '/explore/Moscow-Russia/Thailand' },
      { title: 'Шри-Ланка', link: '/explore/Moscow-Russia/Sri_Lanka' },
      { title: 'Индия', link: '/explore/Moscow-Russia/India' },
      { title: 'Китай', link: '/explore/Moscow-Russia/China' },
      { title: 'Гонконг', link: '/explore/Moscow-Russia/Hong_Kong-China' },
      {
        title: 'Индонезия (с пересадкой)',
        link: '/explore/Moscow-Russia/Indonesia',
      },
      {
        title: 'Малайзия (с пересадкой)',
        link: '/explore/Moscow-Russia/Malaysia',
      },
      {
        title: 'Вьетнам',
        link: '/explore/Moscow-Russia/Vietnam',
      },
    ],
  },
  // Убираем на зимний сезон
  // {
  //   metaregion: {
  //     title: 'Черное море',
  //     link: '/explore/Moscow-Russia/Black_Sea',
  //     image_url:
  //       'https://img.cdn.level.travel/seo_images/AB/x543x285_Abkhazia-tiny.jpg',
  //   },
  //   regions: [
  //     {
  //       title: 'Краснодарский край',
  //       link: '/explore/Moscow-Russia/Krasnodar_Krai-Russia',
  //     },
  //     {
  //       title: 'Абхазия',
  //       link: '/explore/Moscow-Russia/Abhasia',
  //     },
  //     {
  //       title: 'Крым (без перелета)',
  //       link: '/tophotels/any/Crimea-Russia',
  //     },
  //     { title: 'Батуми (без перелета)', link: '/tophotels/any/Batumi-Georgia' },
  //   ],
  // },
  {
    metaregion: {
      title: 'Ближнее зарубежье',
      link: '/explore/Moscow-Russia/Foreign_countries',
      image_url: 'https://img.cdn.level.travel/seo_images/BY/Belarus-tiny.jpg',
    },
    regions: [
      { title: 'Абхазия', link: '/explore/Moscow-Russia/Abhasia' },
      { title: 'Беларусь', link: '/explore/Moscow-Russia/Belarus' },
      { title: 'Казахстан', link: '/explore/Moscow-Russia/Kazakhstan' },
      { title: 'Армения', link: '/explore/Moscow-Russia/Armenia' },
      { title: 'Грузия', link: '/explore/Moscow-Russia/Georgia' },
      { title: 'Узбекистан', link: '/explore/Moscow-Russia/Uzbekistan' },
      { title: 'Азербайджан', link: '/explore/Moscow-Russia/Azerbaijan' },
      { title: 'Киргизия', link: '/explore/Moscow-Russia/Kyrgyzstan' },
      { title: 'Таджикистан', link: '/explore/Moscow-Russia/Tajikistan' },
    ],
  },
];
